import React from 'react'

import { AcornsIcon } from '@acorns/icons'

import { TierProduct } from 'generated/types'

import { DYNAMIC_COPY } from './copy'
import {
  IconContainer,
  ProductHeaderCopy,
  ProductHeaderSubtitle,
  ProductHeaderTitle,
  TierControlItem,
} from './styled-components'

type Props = {
  productKey: string
  showValueProps: boolean
}

export function renderProducts(productKeys: string[], tierProducts: TierProduct[]) {
  const displayedProductKeys: string[] = tierProducts.map(({ key }) => key.toLowerCase())

  return productKeys.map(productKey => {
    return (
      <TierProductComponent
        key={productKey}
        productKey={productKey}
        showValueProps={displayedProductKeys.includes(productKey)}
      />
    )
  })
}

const TierProductComponent = ({ productKey, showValueProps }: Props) => {
  const productCopy = DYNAMIC_COPY.products?.[productKey]
  if (!productCopy) {
    return null
  }

  return (
    <TierControlItem key={productKey}>
      {showValueProps ? (
        <AcornsIcon icon={AcornsIcon.Icon.CheckmarkGreenNarrow} width="22px" height="22px" />
      ) : (
        <IconContainer>
          <AcornsIcon icon={AcornsIcon.Icon.InlineClose} width="12px" height="12px" />
        </IconContainer>
      )}
      <ProductHeaderCopy>
        <ProductHeaderTitle isInvalid={!showValueProps}>{productCopy.title}</ProductHeaderTitle>
        <ProductHeaderSubtitle>{productCopy.subtitle}</ProductHeaderSubtitle>
      </ProductHeaderCopy>
    </TierControlItem>
  )
}
